export default __webpack_public_path__ + "navigation-guides-ui-steps-view-controller-960-896c40cd6cf5e11902264a9cda6eb0ad.png";